export enum StatsigMarket {
  NL = 'NL',
  DE = 'DE',
  Unknown = 'unknown',
}
